import React, { useEffect, useState } from "react";
import HomeNavbar from "../homepage/HomeNavbar";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from 'react-router-dom';
import { FormControlLabel, Checkbox, Typography, Box } from "@mui/material";

const QuickRegistrationForm = () => {
  const { jobId } = useParams(); // Retrieve the job ID from the URL
  const[droneJobs,setDroneJobs] = useState([]);
  const [formData, setFormData] = useState({
    mobileNo: "",
    email: "",
    fullName: "",
    state: "",
    district: "",
    jobId: jobId,
    education: "",
    specialization: "",
    pwd: "",
    reference: "",
    document: null,
    gender: "",
    highestQualification: "",
    courseName: "",
    courseSpecialization: "",
    university: "",
    courseType: "",
    passingYear: "",
    isFresher: "",
  });
 
 
  const [isLoading, setIsLoading] = useState(false);
  const [mobileOtp, setMobileOtp] = useState("");
  const [otpSent, setOtpSent] = useState({ mobile: false, email: false });
  const [isOtpVerified, setIsOtpVerified] = useState({
    mobile: false,
    email: false,
  });
 
  const [showAlert, setShowAlert] = useState(false);
  const [isFresher, setIsFresher] = useState(formData.isFresher || ""); // default to existing formData value if available
 const[droneJobb,setDroneJobb] = useState(formData.droneJobb|| "")
  const stateDistrictData = {
   "Andhra Pradesh": [
    "Anantapur", "Chittoor", "East Godavari", "Guntur", "Krishna",
    "Kurnool", "Nellore", "Prakasam", "Srikakulam", "Visakhapatnam",
    "Vizianagaram", "West Godavari", "YSR Kadapa"
  ],
 
   "Arunachal Pradesh": [
    "Tawang", "West Kameng", "East Kameng", "Papum Pare", "Kurung Kumey",
    "Kra Daadi", "Lower Subansiri", "Upper Subansiri", "West Siang",
    "East Siang", "Siang", "Upper Siang", "Lower Siang",
    "Lower Dibang Valley", "Dibang Valley", "Anjaw", "Lohit", "Namsai",
    "Changlang", "Tirap", "Longding"
  ],
 
    "Assam": [
    "Baksa", "Barpeta", "Biswanath", "Bongaigaon", "Cachar", "Charaideo",
    "Chirang", "Darrang", "Dhemaji", "Dhubri", "Dibrugarh", "Goalpara",
    "Golaghat", "Hailakandi", "Hojai", "Jorhat", "Kamrup Metropolitan",
    "Kamrup", "Karbi Anglong", "Karimganj", "Kokrajhar", "Lakhimpur",
    "Majuli", "Morigaon", "Nagaon", "Nalbari", "Dima Hasao", "Sivasagar",
    "Sonitpur", "South Salmara-Mankachar", "Tinsukia", "Udalguri",
    "West Karbi Anglong"
  ],
 
  "Bihar": [
    "Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur",
    "Bhojpur", "Buxar", "Darbhanga", "East Champaran", "Gaya", "Gopalganj",
    "Jamui", "Jehanabad", "Kaimur", "Katihar", "Khagaria", "Kishanganj",
    "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur",
    "Nalanda", "Nawada", "Patna", "Purnia", "Rohtas", "Saharsa", "Samastipur",
    "Saran", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul",
    "Vaishali", "West Champaran"
  ],
 
   "Chhattisgarh": [
    "Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur",
    "Bilaspur", "Dantewada", "Dhamtari", "Durg", "Gariaband", "Janjgir-Champa",
    "Jashpur", "Kabirdham", "Kanker", "Kondagaon", "Korba", "Koriya",
    "Mahasamund", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon",
    "Sukma", "Surajpur", "Surguja"
  ],
 
    "Goa": ["North Goa", "South Goa"],
 
    "Gujarat": [
      "Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch",
      "Bhavnagar", "Botad", "Chhota Udaipur", "Dahod", "Dang", "Devbhoomi Dwarka",
      "Gandhinagar", "Gir Somnath", "Jamnagar", "Junagadh", "Kheda", "Kutch",
      "Mahisagar", "Mehsana", "Morbi", "Narmada", "Navsari", "Panchmahal",
      "Patan", "Porbandar", "Rajkot", "Sabarkantha", "Surat", "Surendranagar",
      "Tapi", "Vadodara", "Valsad"
    ],
    "Haryana": [
      "Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram",
      "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh",
      "Mewat", "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa",
      "Sonipat", "Yamunanagar"
    ],
 
   "Himachal Pradesh": [
    "Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu",
    "Lahaul and Spiti", "Mandi", "Shimla", "Sirmaur", "Solan", "Una"
  ],
  "Jharkhand": [
    "Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum",
    "Garhwa", "Giridih", "Godda", "Gumla", "Hazaribagh", "Jamtara",
    "Khunti", "Koderma", "Latehar", "Lohardaga", "Pakur", "Palamu",
    "Ramgarh", "Ranchi", "Sahebganj", "Seraikela Kharsawan", "Simdega",
    "West Singhbhum"
  ],
  "Karnataka": [
    "Bagalkot", "Ballari", "Belagavi", "Bengaluru Rural", "Bengaluru Urban",
    "Bidar", "Chamarajanagar", "Chikkaballapur", "Chikkamagaluru", "Chitradurga",
    "Dakshina Kannada", "Davanagere", "Dharwad", "Gadag", "Hassan", "Haveri",
    "Kalaburagi", "Kodagu", "Kolar", "Koppal", "Mandya", "Mysuru", "Raichur",
    "Ramanagara", "Shivamogga", "Tumakuru", "Udupi", "Uttara Kannada",
    "Vijayapura", "Yadgir"
  ],
 
    "Kerala": [
    "Alappuzha", "Ernakulam", "Idukki", "Kannur", "Kasaragod", "Kollam",
    "Kottayam", "Kozhikode", "Malappuram", "Palakkad", "Pathanamthitta",
    "Thiruvananthapuram", "Thrissur", "Wayanad"
  ],
  "Madhya Pradesh": [
    "Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat",
    "Barwani", "Betul", "Bhind", "Bhopal", "Burhanpur", "Chhatarpur",
    "Chhindwara", "Damoh", "Datia", "Dewas", "Dhar", "Dindori",
    "Guna", "Gwalior", "Harda", "Hoshangabad", "Indore", "Jabalpur",
    "Jhabua", "Katni", "Khandwa", "Khargone", "Mandla", "Mandsaur",
    "Morena", "Narsinghpur", "Neemuch", "Panna", "Raisen", "Rajgarh",
    "Ratlam", "Rewa", "Sagar", "Satna", "Sehore", "Seoni", "Shahdol",
    "Shajapur", "Sheopur", "Shivpuri", "Sidhi", "Singrauli", "Tikamgarh",
    "Ujjain", "Umaria", "Vidisha"
  ],
  "Maharashtra": [
    "Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara",
    "Buldhana", "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Hingoli",
    "Jalgaon", "Jalna", "Kolhapur", "Latur", "Mumbai City",
    "Mumbai Suburban", "Nagpur", "Nanded", "Nandurbar", "Nashik",
    "Osmanabad", "Palghar", "Parbhani", "Pune", "Raigad", "Ratnagiri",
    "Sangli", "Satara", "Sindhudurg", "Solapur", "Thane", "Wardha",
    "Washim", "Yavatmal"
  ],
 
  "Manipur": [
    "Bishnupur", "Chandel", "Churachandpur", "Imphal East", "Imphal West",
    "Jiribam", "Kakching", "Kamjong", "Kangpokpi", "Noney", "Pherzawl",
    "Senapati", "Tamenglong", "Tengnoupal", "Thoubal", "Ukhrul"
  ],
  "Meghalaya": [
    "East Garo Hills", "East Jaintia Hills", "East Khasi Hills", "North Garo Hills",
    "Ri Bhoi", "South Garo Hills", "South West Garo Hills", "South West Khasi Hills",
    "West Garo Hills", "West Jaintia Hills", "West Khasi Hills"
  ],
  "Mizoram": [
    "Aizawl", "Champhai", "Kolasib", "Lawngtlai", "Lunglei", "Mamit", "Saiha", "Serchhip"
  ],
  "Nagaland": [
    "Dimapur", "Kiphire", "Kohima", "Longleng", "Mokokchung", "Mon", "Peren",
    "Phek", "Tuensang", "Wokha", "Zunheboto"
  ],
  "Odisha": [
    "Angul", "Balangir", "Balasore", "Bargarh", "Bhadrak", "Boudh", "Cuttack",
    "Debagarh", "Dhenkanal", "Gajapati", "Ganjam", "Jagatsinghpur", "Jajpur",
    "Jharsuguda", "Kalahandi", "Kandhamal", "Kendrapara", "Kendujhar", "Khordha",
    "Koraput", "Malkangiri", "Mayurbhanj", "Nabarangpur", "Nayagarh", "Nuapada",
    "Puri", "Rayagada", "Sambalpur", "Subarnapur", "Sundergarh"
  ],
 
   "Punjab": [
    "Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib",
    "Fazilka", "Ferozepur", "Gurdaspur", "Hoshiarpur", "Jalandhar",
    "Kapurthala", "Ludhiana", "Mansa", "Moga", "Muktsar",
    "Pathankot", "Patiala", "Rupnagar", "Sangrur", "Shaheed Bhagat Singh Nagar",
    "Sri Muktsar Sahib", "Tarn Taran"
  ],
  "Rajasthan": [
    "Ajmer", "Alwar", "Banswara", "Baran", "Barmer",
    "Bharatpur", "Bhilwara", "Bikaner", "Bundi", "Chittorgarh",
    "Churu", "Dausa", "Dholpur", "Dungarpur", "Hanumangarh",
    "Jaipur", "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu",
    "Jodhpur", "Karauli", "Kota", "Nagaur", "Pali",
    "Pratapgarh", "Rajsamand", "Sawai Madhopur", "Sikar", "Sirohi",
    "Sri Ganganagar", "Tonk", "Udaipur"
  ],
  "Sikkim": [
    "East Sikkim", "North Sikkim", "South Sikkim", "West Sikkim"
  ],
  "Tamil Nadu": [
    "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore",
    "Dharmapuri", "Dindigul", "Erode", "Kallakurichi", "Kanchipuram",
    "Kanyakumari", "Karur", "Krishnagiri", "Madurai", "Nagapattinam",
    "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram",
    "Ranipet", "Salem", "Sivaganga", "Tenkasi", "Thanjavur",
    "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli", "Tirupattur",
    "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur",
    "Vellore", "Viluppuram", "Virudhunagar"
  ],
  "Telangana": [
    "Adilabad", "Bhadradri Kothagudem", "Hyderabad", "Jagtial", "Jangaon",
    "Jayashankar Bhupalapally", "Jogulamba Gadwal", "Kamareddy", "Karimnagar",
    "Khammam", "Komaram Bheem Asifabad", "Mahabubabad", "Mahbubnagar",
    "Mancherial", "Medak", "Medchal–Malkajgiri", "Mulugu", "Nagarkurnool",
    "Nalgonda", "Narayanpet", "Nirmal", "Nizamabad", "Peddapalli",
    "Rajanna Sircilla", "Ranga Reddy", "Sangareddy", "Siddipet",
    "Suryapet", "Vikarabad", "Wanaparthy", "Warangal Rural",
    "Warangal Urban", "Yadadri Bhuvanagiri"
  ],
 
    "Tripura": [
    "Dhalai", "Gomati", "Khowai", "North Tripura", "Sepahijala",
    "South Tripura", "Unakoti", "West Tripura"
  ],
  "Uttar Pradesh": [
    "Agra", "Aligarh", "Ambedkar Nagar", "Amethi", "Amroha",
    "Auraiya", "Ayodhya", "Azamgarh", "Badaun", "Baghpat",
    "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki",
    "Bareilly", "Basti", "Bhadohi", "Bijnor", "Bulandshahr",
    "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah",
    "Farrukhabad", "Fatehpur", "Firozabad", "Gautam Buddha Nagar",
    "Ghaziabad", "Ghazipur", "Gonda", "Gorakhpur", "Hamirpur",
    "Hapur", "Hardoi", "Hathras", "Jalaun", "Jaunpur",
    "Jhansi", "Kannauj", "Kanpur Dehat", "Kanpur Nagar",
    "Kasganj", "Kaushambi", "Kushinagar", "Lakhimpur Kheri",
    "Lalitpur", "Lucknow", "Maharajganj", "Mahoba", "Mainpuri",
    "Mathura", "Mau", "Meerut", "Mirzapur", "Moradabad",
    "Muzaffarnagar", "Pilibhit", "Pratapgarh", "Raebareli",
    "Rampur", "Saharanpur", "Sambhal", "Sant Kabir Nagar",
    "Shahjahanpur", "Shamli", "Shrawasti", "Siddharthnagar",
    "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi"
  ],
  "Uttarakhand": [
    "Almora", "Bageshwar", "Chamoli", "Champawat", "Dehradun",
    "Haridwar", "Nainital", "Pauri Garhwal", "Pithoragarh",
    "Rudraprayag", "Tehri Garhwal", "Udham Singh Nagar",
    "Uttarkashi"
  ],
  "West Bengal": [
    "Alipurduar", "Bankura", "Birbhum", "Cooch Behar",
    "Dakshin Dinajpur", "Darjeeling", "Hooghly", "Howrah",
    "Jalpaiguri", "Jhargram", "Kalimpong", "Kolkata",
    "Malda", "Murshidabad", "Nadia", "North 24 Parganas",
    "Paschim Bardhaman", "Paschim Medinipur", "Purba Bardhaman",
    "Purba Medinipur", "Purulia", "South 24 Parganas",
    "Uttar Dinajpur"
  ],
  };
 
  const educationOptions = [
    "Below 10th",
    "10th Pass",
    "12th Pass",
    "ITI",
    "Diploma",
    "Graduate",
    "Post Graduate",
    "Doctorate",
  ];
 
  const referenceOptions = [
    "NSDC Website",
    "Social Media",
    "Job Portal",
    "Friend/Family",
    "Other",
  ];
 
  const specializationOptions = [
    "Specialization 1",
    "Specialization 2",
    "Specialization 3",
  ];
 
  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
 
    if (name === "isFresher") {
      setIsFresher(value); // Update fresher status
    } else if (name === "droneJobb") {
      setDroneJobb(value); // Update drone job status
    }
    
 
    setFormData({
      ...formData,
 
      [name]: value,
    });
  };
  // const handleDropdownChanges = (e) => {
  //   const { name, value } = e.target;
 
  //   if (name === "droneJobb") {
  //     setIsFresher(value); // Update fresher status
  //   } 
    
 
  //   setFormData({
  //     ...formData,
 
  //     [name]: value,
  //   });
  // };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Optional: Smooth scrolling animation
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);
 
  const genderOptions = ["Male", "Female", "Other"];
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleMobileSubmit = async (e) => {
    try {
      setIsLoading(true);
      const response = await axios.post(

        process.env.REACT_APP_API_URL + "/login",

        {
          phoneNumber: formData.mobileNo,
          email: formData.email,
        }
      );
      setIsLoading(false);
      if (response?.data?.status === "success") {
        setOtpSent({ ...otpSent, mobile: true, email: true });
        setIsOtpVerified((prevState) => ({ ...prevState, mobile: false })); // Reset OTP verified status
        toast.success("OTP Sent Successfully.");
      } else {
        toast.error(response?.data?.message || "Failed to send OTP.");
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong!");
    }
  };
 
  const handleResendOtp = () => {
    handleMobileSubmit(); // Calls the function to resend OTP
  };
 
  const handleMobileOtpVerify = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/verifyOtp",
        {
          phoneNumber: formData.mobileNo,
          email: formData.email,
          otp: mobileOtp,
        }
      );
      setIsLoading(false);
      if (response?.data?.status === "success") {
        toast.success("Mobile OTP verified successfully.");
        setIsOtpVerified((prevState) => ({ ...prevState, mobile: true }));
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong!");
    }
  };
 
 
  const getDistrictOptions = () => {
    if (!formData.state) {
      return [];
    }
 
    return stateDistrictData[formData.state] || [];
  };
 
  const validateForm = () => {
    // Check if all required fields are filled
    const requiredFields = [
      "mobileNo",
      "fullName",
      "state",
      "district",
      "education",
      "specialization",
      "pwd",
      "gender",
    ];
 
    for (let field of requiredFields) {
      if (
        !formData[field] ||
        (typeof formData[field] === "string" && formData[field].trim() === "")
      ) {
        return false;
      }
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    if (!isOtpVerified.mobile) {
      toast.error("Please verify your mobile number before submitting the form.");
      return;
    }
 
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
 
    if (isFresher === "") {
      toast.error("Please select whether you are a fresher.");
      return;
    }
 
    // Check if the checkbox is checked
    const checkbox = document.getElementById("text1");
    if (!checkbox.checked) {
      toast.error("Please acknowledge the terms and conditions.");
      return;
    }
 
    const formDataToSend = new FormData();
    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        formDataToSend.append(key, formData[key]);
      }
    }
 
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/addQuickRegistration`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
 
      toast.success("Form Submitted Successfully!");
      setShowAlert(true);
 
      // Reset the form data
      setFormData({
        mobileNo: "",
        email: "",
        fullName: "",
        state: "",
       jobId: jobId,
        district: "",
        education: "",
        specialization: "",
        pwd: "",
        reference: "",
        document: null,
        gender: "",
        highestQualification: "",
        courseName: "",
        courseSpecialization: "",
        university: "",
        courseType: "",
        passingYear: "",
        isFresher: "",
      });
      setIsFresher(""); // Reset fresher status
 
      // Reset the checkbox
      const checkbox = document.getElementById("text1");
      if (checkbox) checkbox.checked = false;
      // Reset OTP fields and state
      setMobileOtp("");
      setOtpSent({ mobile: false, email: false });
      setIsOtpVerified((prevState) => ({ ...prevState, mobile: false }));
      // Clear file input
      document.querySelector('input[name="document"]').value = "";
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => setShowAlert(false), 3000);
    } catch (err) {
      toast.error("Error submitting the form.");
      setShowAlert(false);
    }
  };
 
 
 useEffect(()=>{
  const ff = async()=>{
    try{
      const ass = await axios.get(`${process.env.REACT_APP_API_URL}/getAllDroneJob`);
    setDroneJobs(ass.data.data.droneJobs);

    }catch(err){
      console.log("error")
    }
  }
  ff();
 },[]);

 
 
 
  return (
    <>
      <HomeNavbar />
      <div className="quick-registration-header my-4">
        <h1>Hi Guest!</h1>
        <p>
          Let the top employers of your industry reach you. Register on Drone
          Planet for free!
        </p>
      </div>
 
      <div className="quick-registration-form-container">
      <h2>Apply Here<span style={{color: 'red'}}> *</span></h2>

        <form onSubmit={handleSubmit} className="quick-registration-form">
        <div className="row">
  {/* Mobile OTP Section */}
  <div className="col-md-6 d-flex align-items-center justify-content-center">
  {/* Mobile Number/OTP Section */}
  <div className="form-group me-2 w-75 position-relative">
    <label className="blue-label">
      {otpSent.mobile ? "Mobile OTP " : "Mobile No "}<span style={{color: 'red'}}>*</span>
    </label>
    {!otpSent.mobile ? (
      <input
        type="tel"
        name="mobileNo"
        value={formData.mobileNo}
        onChange={handleChange}
        required
        className="form-control"
        placeholder="Enter Mobile Number"
        pattern="[0-9]{10}" // Only allows exactly 10 digits
        maxLength="10" // Limits input to 10 characters
        onInput={(e) => {
          e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only digits
        }}
      />
    ) : (
      <div className="position-relative">
        <input
          type="text"
          name="mobileOtp"
          className="form-control"
          value={mobileOtp}
          onChange={(e) => setMobileOtp(e.target.value)}
          placeholder="Enter Mobile OTP"
          required
        />
        {isOtpVerified.mobile && (
          <span className="checkmark position-absolute">&#10003;</span>
        )}
      </div>
    )}
    {otpSent.mobile && (
      <small className="text-muted">
        Didn't receive the OTP?{" "}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleResendOtp();
          }}
          style={{ cursor: "pointer", textDecoration: "underline" }}
        >
          Resend OTP
        </a>
      </small>
    )}
  </div>

  {/* Submit or Verify Button */}
  <div className="d-flex w-50 mt-3">
  {!otpSent.mobile ? (
    <button
      type="button"
      className="btn btn-primary"
      onClick={handleMobileSubmit}
      disabled={isLoading}
       // This makes the button fill the width of the input field
    >
      Submit
    </button>
  ) : (
    <button
      type="button"
      className="btn btn-primary mb-4 verify-btn"
      onClick={handleMobileOtpVerify}
      disabled={isLoading}
      // This makes the button fill the width of the input field
    >
      Verify
    </button>
  )}
</div>

{/* Add custom CSS */}
<style jsx>{`
  @media (max-width: 768px) {
    .verify-btn {
      margin-top: -19px; /* Adjust this value to control the vertical position */
    }
  }
`}</style>

</div>

 
 
  {/* Email OTP Section */}
  <div className="col-md-4">
    <div className="form-group">
      <label className="blue-label">Email ID <span style={{color: 'red'}}>*</span></label>
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        required
        placeholder="Enter your email address"
        className="form-control"
      />
    </div>
  </div>
</div>
 
 
          <hr />
 
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">Full Name (पूरा नाम) <span style={{color: 'red'}}>*</span></label>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Enter Your Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">Current State (राज्य) <span style={{color: 'red'}}>*</span></label>
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select State</option>
                  {Object.keys(stateDistrictData).map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
            </div>
 
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">Current District (जिला) <span style={{color: 'red'}}>*</span></label>
                <select
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select District</option>
                  {getDistrictOptions().map((district) => (
                    <option key={district} value={district}>
                      {district}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
 
          <hr />
 
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">Education (शिक्षा) <span style={{color: 'red'}}>*</span></label>
                <select
                  name="education"
                  value={formData.education}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  {educationOptions.map((education) => (
                    <option key={education} value={education}>
                      {education}
                    </option>
                  ))}
                </select>
              </div>
            </div>
 
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">
                  Specialization (विशेषज्ञता) <span style={{color: 'red'}}>*</span>
                </label>
                <input
                  type="text"
                  name="specialization"
                  placeholder="Enter Your Specialization"
                  value={formData.specialization}
                  onChange={handleChange}
                  required
                >          
                </input>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">PWD
                <span style={{ color: "#007bff", fontSize: "0.75rem" }}>
                    (Person With Disability) <span style={{color: 'red'}}>*</span>
                  </span>
                </label>
                <select
                  name="pwd"
                  value={formData.pwd}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
          </div>
 
          <hr />
 
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">Reference <span style={{color: 'red'}}>*</span></label>
                <select
                  name="reference"
                  value={formData.reference}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  {referenceOptions.map((reference) => (
                    <option key={reference} value={reference}>
                      {reference}
                    </option>
                  ))}
                </select>
              </div>
            </div>
 
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">Resume <span style={{color: 'red'}}>*</span></label>
                <input
                  type="file"
                  // id="resume"
                  name="document"
                  // accept=".pdf"
                  // value={formData.resume}
                  onChange={handleChange}
                />
              </div>
            </div>
 
            <div className="col-md-4">
              <div className="form-group">
                <label className="blue-label">Gender <span style={{color: 'red'}}>*</span></label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  {genderOptions.map((gender) => (
                    <option key={gender} value={gender}>
                      {gender}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </form>
        <form onSubmit={handleSubmit} className="quick-registration-form">
          {/* Educational Details */}
          <div className="form-section">
            <div className="section-heading">
              <h4>10th / 12th / ITI / Diploma</h4>
            </div>
            <div className="education-section">
              <div className="education-group">
                {/* Fields for 10th / 12th / ITI / Diploma */}
                <div className="form-group">
                  <label className="small-label">Highest Qualification:</label>
                  <select
                    name="highestQualification"
                    value={formData.highestQualification}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Below10th">Below 10th Pass</option>
                    <option value="10th">10th</option>
                    <option value="12th">12th</option>
                    <option value="iti">ITI</option>
                    <option value="Diploma">Diploma</option>
                    {/* Add more options as needed */}
                  </select>
                </div>
 
                <div className="form-group">
                  <label className="small-label">Course Name:</label>
                  <input
                    type="text"
                    name="courseName"
                    placeholder="Enter Course Name"
                    value={formData.courseName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label className="small-label">Specialization:</label>
                  <input
                    type="text"
                    name="courseSpecialization"
                    placeholder="Enter Course Specialization"
                    value={formData.courseSpecialization}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label className="small-label">University/Institution:</label>
                  <input
                    type="text"
                    name="university"
                    placeholder="Enter University/Institution Name"
                    value={formData.university}
                    onChange={handleChange}
                  ></input>
                </div>
                <div className="form-group">
                  <label className="small-label">Course Type:</label>
                  <select
                    name="courseType" // name ko formData se match karein
                    value={formData.courseType} // value ko sahi key se bind karein
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="full-time">Full Time</option>
                    <option value="part-time">Part Time</option>
                  </select>
                </div>
                <div className="form-group">
                <label className="small-label">Passing Year:</label>
                <input
                  type="text"
                  name="passingYear"
                  value={formData.passingYear}
                  onChange={(e) => {
                    // Allow only numbers and limit input to 4 digits
                    const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-digit characters
                    if (value.length <= 4) {
                      handleChange(e); // Call the custom handler only if input is valid
                    }
                  }}
                  maxLength="4" // Ensures only 4 characters can be typed
                  className="form-control"
                  placeholder="Enter Passing Year"
                  required
                />
 </div>

              </div>
            </div>
          </div>
          {/* Horizontal Line */}
          <hr />
        </form>
        {/* <form onSubmit={handleSubmit} className="update-resume-form"> */}
        {/* <div className="quick-registration-form"> */}
   
        {/* <div className="form-group">
        <label htmlFor="droneJobId">Select the Job:</label>
        <select
          id="droneJobb"
          name="droneJobb"
          className="form-control"
          value={droneJobb}
          onChange={handleDropdownChange}
        >
          <option value="">Select a job</option>
          {droneJobs.map((e) => (
            <option key={e.id} value={e.id}>
              {e.title}
            </option>
          ))}
        </select>
      </div> */}
   
  </div>
  <form onSubmit={handleSubmit} className="quick-registration-form">
  <div className="form-group">
    <h3>Update Experience Details</h3>
    <div className="form-group">
      <label htmlFor="isFresher">Are you a fresher?</label>
      <select
        id="isFresher"
        name="isFresher"
        className="form-control"
        value={isFresher}
        onChange={handleDropdownChange}
      >
        <option value="">Select</option>
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </select>
    </div>
    <Box sx={{ px: 2, mt: 1 }}>
      <FormControlLabel
        control={<Checkbox id="text1" />}
        label={
          <Typography
            variant="body2"
            sx={{
              fontSize: '13px',
              color: 'gray',
              fontFamily: 'Inter, sans-serif',
              lineHeight: 1.5,
            }}
          >
            I hereby acknowledge that I have read and agree to the terms and conditions as outlined in the user agreement. Furthermore, I affirm that all the information I have provided is accurate and truthful to the best of my knowledge.
          </Typography>
        }
        sx={{
          alignItems: 'flex-start',
        }}
      />
    </Box>
    <div className="form-group text-center">
      <button type="submit" className="btn btn-primary btn-block">
        Submit
      </button>
    </div>
  </div>
  
</form>

 
       
     
    </>
  );
};
export default QuickRegistrationForm;